import React from 'react';
import { PostExcerpt } from './PostExcerpt';

export default function PostFeed({ posts }) {
  return (
    <div className="">
      {posts && posts.map((post, key) => <PostExcerpt {...post} key={key} />)}
    </div>
  );
}
